import React, {useEffect, useState} from 'react'

interface IProps {
    className?: string
    inputClassName?: string
    onChanged?: (e?: string) => void
    onFocus?: (e?: any) => void
    value?: any
    id?: string
    type?: 'text' | 'password' | 'datetime-local' | 'number'
    onEnterKeyPress?: () => void
    placeholder?: string
}

const UnderLineInput: React.FC<IProps> = ({
    className,
    inputClassName,
    value,
    onChanged,
    onFocus,
    onEnterKeyPress,
    id,
    type,
    placeholder,
}) => {
    const [valueState, setValueState] = useState<any>()

    useEffect(() => {
        setValueState(value)
    }, [value])

    return (
        <div className={`${className}`}>
            <input
                type={type}
                placeholder={placeholder ? placeholder : ''}
                id={id}
                value={valueState}
                onFocus={e => {
                    if (onFocus) {
                        onFocus(e.target.value)
                    }
                }}
                onChange={e => {
                    if (onChanged) {
                        onChanged(e.target.value)
                    }
                    setValueState(e.target.value)
                }}
                onKeyDown={e => {
                    if (e.key === 'Enter' && onEnterKeyPress) onEnterKeyPress()
                }}
                className={`border-0 border-b bg-transparent relative w-[100%] px-[5px] py-[3px] border-line02 ${inputClassName}`}
            />
        </div>
    )
}

export default UnderLineInput
